import React, { useState } from "react";
import { DoubleArrow } from "@mui/icons-material";
import { themes } from "services/constants";
import dayjs from "dayjs";
import {
  CardContent,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Avatar,
  Card,
  CardHeader,
  IconButton,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import GradingIcon from "@mui/icons-material/Grading";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import CategoryIcon from "@mui/icons-material/Category";
import { CustomButton } from "components/CustomComponents";
import {
  CustomButtonWithBorder,
  CustomButtonWithOutLoader,
} from "components/CustomComponents/CustomButton";
import sessionHandling from "services/utils/notificationUtils";
import { CustomAutoComplete } from "components/CustomComponents";
import { useFetch } from "services/hooks/useFetch";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Controller } from "react-hook-form";
import { customAPI } from "services/utils/CustomAPI";
import { showToast } from "services/utils/Status";

export const EditAssignmentPanel = ({
  onClose,
  reCallApi,
  userData,
  AssignmentData,
  setTriggerApi,
  setUpdateData,
  reCallGradeApi,
  reCallGroupApi,
  reCallCategoryApi,
}) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const {
    setValue,
    watch,
    unregister,
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      trigger_api: true,
      get_individual_data: false,
      grade_data: [],
      grade_history: [],
      group_history: [],
      category_history: [],
      sft_grp_name: "",
      sft_grade_name: "",
      sft_category_name: "",
    },
  });
  const { domain } = useSelector((state) => state.tokenReducer);
  const [expanded, setExpanded] = useState([]);
  const lastEditableDate = dayjs(
    userData?.last_editable_date ?? userData?.latest_pay_date,
    "DD-MM-YYYY",
  );
  const minDate = lastEditableDate.add(1, "day");
  const { result: shiftGradeData } = useFetch(
    `${domain}administration/shiftroster/shiftgrade/shift-grades/`,
  );
  const { result: shiftGrpData } = useFetch(
    `${domain}administration/shiftroster/shiftgroups/shift-groups/`,
  );
  const { result: getCategoryData } = useFetch(
    `${domain}administration/shiftroster/userassignment/shiftcategory/shift-categories-with-user-count/?company_id=${requestCompanyId}`,
  );

  const handleChange = (index, item) => {
    setExpanded((prev) => {
      if (prev.includes(index)) {
        if (item.category === "Shift Grade") {
          setValue("sft_grade_name", null);
          setValue("effective_from_grade", null);
          unregister("sft_grade_name");
          unregister("effective_from_grade");
        }
        if (item.category === "Shift Group") {
          setValue("sft_grp_name", null);
          setValue("effective_from_group", null);
          unregister("sft_grp_name");
          unregister("effective_from_group");
        }
        if (item.category === "Shift Category") {
          setValue("sft_category_name", null);
          setValue("effective_from_category", null);
          unregister("sft_category_name");
          unregister("effective_from_category");
        }
        return prev.filter((i) => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const updateSftGrp = (event, data) => {
    if (data) {
      setValue("sft_grp_name", data?.label || "");
      setValue("sft_grp_id", data?.id || "");
    }
  };
  const updateSftGrade = (event, data) => {
    if (data) {
      setValue("sft_grade_name", data?.label || "");
      setValue("sft_grade_id", data?.id || "");
    }
  };

  const updateSftCategory = (event, data) => {
    if (data) {
      setValue("sft_category_name", data?.label || "");
      setValue("sft_category_id", data?.id || "");
    }
  };

  const assignmentItems = [
    {
      category: "Shift Grade",
      value:
        AssignmentData?.length !== 0
          ? AssignmentData?.shift_grades[0]?.name
          : "",
      effective_from: AssignmentData?.shift_grades[0]?.effective_from,
      icon: <GradingIcon color="success" />,
    },
    {
      category: "Shift Group",
      value:
        AssignmentData?.length !== 0
          ? AssignmentData?.shift_groups[0]?.name
          : "",
      icon: <Diversity3Icon color="success" />,
      effective_from: AssignmentData?.shift_groups[0]?.effective_from,
    },
    {
      category: "Shift Category",
      value:
        AssignmentData?.length !== 0
          ? AssignmentData?.shift_categories[0]?.name
          : "",
      icon: <CategoryIcon color="success" />,
      effective_from: AssignmentData?.shift_categories[0]?.effective_from,
    },
  ];

  const renderAutoComplete = (item) => {
    if (item.category === "Shift Grade") {
      return (
        <>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 4,
              ml: 1.5,
            }}
          >
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                New Shift Grade To Be Assigned{" "}
                <span style={{ color: themes?.redColor }}>*</span>
              </Typography>
              <CustomAutoComplete
                dataList={shiftGradeData
                  ?.filter(
                    (obj) =>
                      obj?.name !== AssignmentData?.shift_grades[0]?.name,
                  )
                  ?.map((obj) => ({
                    ...obj,
                    label: obj?.name,
                  }))}
                {...register("sft_grade_name", {
                  validate: (val) => {
                    if (expanded.includes(0) && !val) {
                      return "Shift grade is required";
                    }
                    return true;
                  },
                })}
                selectedValue={watch("sft_grade_name")}
                updateDataFunction={updateSftGrade}
                placeHolder="Select the shift grade"
                errorMessage={
                  errors?.sft_grade_name?.message
                    ? errors?.sft_grade_name?.message
                    : ""
                }
                textBoxError={errors?.sft_grade_name ? true : false}
              />
            </Box>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Effective From{" "}
                <span style={{ color: themes?.redColor }}>*</span>
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  style={{ width: "100%" }}
                >
                  <Controller
                    name="effective_from_grade"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (expanded.includes(0)) {
                          if (!val) return "Effective From date is required";
                          if (
                            dayjs(val, "DD/MM/YYYY").isBefore(minDate, "day")
                          ) {
                            return `Date must be after ${lastEditableDate.format(
                              "DD/MM/YYYY",
                            )}`;
                          }
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        value={field.value || null}
                        onChange={(date) => field.onChange(date)}
                        format="DD/MM/YYYY"
                        minDate={minDate}
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            error: !!errors?.effective_from_grade,
                            helperText: errors?.effective_from_grade?.message,
                          },
                        }}
                      />
                    )}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
          </Box>
        </>
      );
    }
    if (item.category === "Shift Group") {
      return (
        <>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 4,
              ml: 1.5,
            }}
          >
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                New Shift Group To Be Assigned{" "}
                <span style={{ color: themes?.redColor }}>*</span>
              </Typography>

              <CustomAutoComplete
                dataList={shiftGrpData
                  ?.filter(
                    (obj) =>
                      obj?.name !== AssignmentData?.shift_groups[0]?.name,
                  )
                  ?.map((obj) => ({
                    ...obj,
                    label: obj?.name,
                  }))}
                {...register("sft_grp_name", {
                  validate: (val) => {
                    if (expanded.includes(1) && !val) {
                      return "Shift group is required";
                    }
                    return true;
                  },
                })}
                selectedValue={watch("sft_grp_name")}
                updateDataFunction={updateSftGrp}
                placeHolder="Select the shift group"
                errorMessage={
                  errors?.sft_grp_name?.message
                    ? errors?.sft_grp_name?.message
                    : ""
                }
                textBoxError={errors?.sft_grp_name ? true : false}
              />
            </Box>

            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Effective From{" "}
                <span style={{ color: themes?.redColor }}>*</span>
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  style={{ width: "100%" }}
                >
                  <Controller
                    name="effective_from_group"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (expanded.includes(1)) {
                          if (!val) return "Effective From date is required";
                          if (
                            dayjs(val, "DD/MM/YYYY").isBefore(minDate, "day")
                          ) {
                            return `Date must be after ${lastEditableDate.format(
                              "DD/MM/YYYY",
                            )}`;
                          }
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        value={field.value || null}
                        onChange={(date) => field.onChange(date)}
                        minDate={minDate}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            error: !!errors?.effective_from_group,
                            helperText: errors?.effective_from_group?.message,
                          },
                        }}
                      />
                    )}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
          </Box>
        </>
      );
    }
    if (item.category === "Shift Category") {
      return (
        <>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 4,
              ml: 1.5,
            }}
          >
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                New Shift Category To Be Assigned{" "}
                <span style={{ color: themes?.redColor }}>*</span>
              </Typography>
              <CustomAutoComplete
                dataList={getCategoryData
                  ?.filter(
                    (obj) =>
                      obj?.name !== AssignmentData?.shift_categories[0]?.name,
                  )
                  ?.map((obj) => ({
                    ...obj,
                    label: obj?.name,
                  }))}
                {...register("sft_category_name", {
                  validate: (val) => {
                    if (expanded.includes(2) && !val) {
                      return "Shift category is required";
                    }
                    return true;
                  },
                })}
                selectedValue={watch("sft_category_name")}
                updateDataFunction={updateSftCategory}
                placeHolder="Select the shift group"
                errorMessage={
                  errors?.sft_category_name?.message
                    ? errors?.sft_category_name?.message
                    : ""
                }
                textBoxError={errors?.sft_category_name ? true : false}
              />
            </Box>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Effective From{" "}
                <span style={{ color: themes?.redColor }}>*</span>
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  style={{ width: "100%" }}
                >
                  <Controller
                    name="effective_from_category"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (expanded.includes(2)) {
                          if (!val) return "Effective From date is required";
                          if (
                            dayjs(val, "DD/MM/YYYY").isBefore(minDate, "day")
                          ) {
                            return `Date must be after ${lastEditableDate.format(
                              "DD/MM/YYYY",
                            )}`;
                          }
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        value={field.value || null}
                        onChange={(date) => field.onChange(date)}
                        minDate={minDate}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            error: !!errors?.effective_from_category,
                            helperText:
                              errors?.effective_from_category?.message,
                          },
                        }}
                      />
                    )}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
          </Box>
        </>
      );
    }
    return null;
  };

  const apiMap = {
    "Shift Grade": (data, domain) => {
      const payload = {
        new_shift_grade_id: data.sft_grade_id,
        old_shift_grade_id: AssignmentData?.shift_grades[0]?.shiftgrade_id,
        user_id: userData?.user_id,
        effective_from: data.effective_from_grade
          ? dayjs(data.effective_from_grade).format("YYYY-MM-DD")
          : null,
      };
      return customAPI(
        `${domain}administration/shiftroster/userassignment/shiftgrade/move/shift-grade/?company_id=${requestCompanyId}`,
        "PUT",
        payload,
      );
    },

    "Shift Group": (data, domain) => {
      const payload = {
        shift_group_id: data.sft_grp_id,
        effective_from: data.effective_from_group
          ? dayjs(data.effective_from_group).format("YYYY-MM-DD")
          : null,
        user_ids: [userData?.user_id],
      };
      return customAPI(
        `${domain}administration/shiftroster/userassignment/shiftgroup/move/shift-groups/?company_id=${requestCompanyId}`,
        "PUT",
        payload,
      );
    },

    "Shift Category": (data, domain) => {
      const payload = {
        new_shift_category_id: data.sft_category_id,
        old_shift_category_id:
          AssignmentData?.shift_categories[0]?.shiftcategory_id,
        effective_from: data.effective_from_category
          ? dayjs(data.effective_from_category).format("YYYY-MM-DD")
          : null,
        user_id: userData?.user_id,
      };
      return customAPI(
        `${domain}administration/shiftroster/userassignment/shiftcategory/move/shift-category/?company_id=${requestCompanyId}`,
        "PUT",
        payload,
      );
    },
  };

  const onSubmit = async (data) => {
    setValue("button_loader", true);

    const apiCalls = expanded
      .map((idx) => {
        const category = assignmentItems[idx].category;
        const callApi = apiMap[category];
        if (!callApi) return null;

        return (async () => {
          const res = await callApi(data, domain);
          if (res.ok) {
            return res;
          } else if (res.status === 409) {
            sessionHandling();
          } else {
            throw new Error("REQUEST_FAILED");
          }
        })();
      })
      .filter(Boolean);

    try {
      await Promise.all(apiCalls);
      showToast("success", "Assignment updated.");
      setUpdateData(false);
      onClose();
      reCallApi(true);
      setTriggerApi(true);
      reCallGradeApi(true);
      reCallGroupApi(true);
      reCallCategoryApi(true);
    } catch (err) {
      console.error("[Editassignmentpanel] operation failed:", err);
      showToast(
        "error",
        "Couldn't save the shift assignment. Please try again.",
      );
    } finally {
      setValue("button_loader", false);
    }
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Paper
            elevation={0}
            sx={{
              borderBottom: `1px solid ${themes?.miliedLightGray}`,
              borderRadius: 0,
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              sx={{ padding: 1, backgroundColor: themes?.primary }}
            >
              <Box sx={{ ml: 1 }}>
                <IconButton
                  onClick={onClose}
                  sx={{
                    color: themes?.grayColor,
                    "&:hover": {
                      backgroundColor: themes?.whiteColor,
                    },
                  }}
                >
                  <DoubleArrow />
                </IconButton>
              </Box>

              <Box sx={{ ml: 2.2 }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Assignment
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  View and edit user shift assignment
                </Typography>
              </Box>
            </Box>
          </Paper>

          <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2.5,
              }}
            >
              <Box>
                <Card variant="outlined" sx={{ mb: 2 }}>
                  <CardContent sx={{ display: "flex", gap: 3 }}>
                    <Avatar
                      sx={{
                        width: 75,
                        height: 75,
                        bgcolor: themes?.softMutedGreen,
                        fontSize: 35,
                        fontWeight: "bold",
                        borderRadius: 3,
                      }}
                    >
                      {userData?.employee_name.slice(0, 2).toUpperCase()}
                    </Avatar>

                    <Box
                      display="grid"
                      gridTemplateColumns="1fr 1fr"
                      gap={1.5}
                      sx={{ mt: 1 }}
                    >
                      <Box display="flex" gap={1}>
                        <Typography fontWeight={600} sx={{ width: 120 }}>
                          Employee ID
                        </Typography>
                        <Typography fontWeight={600}>:</Typography>
                        <Typography>{userData?.employee_id}</Typography>
                      </Box>
                      <Box display="flex" gap={1}>
                        <Typography fontWeight={600} sx={{ width: 130 }}>
                          Employee Name
                        </Typography>
                        <Typography fontWeight={600}>:</Typography>
                        <Typography>{userData?.employee_name}</Typography>
                      </Box>

                      <Box display="flex" gap={1}>
                        <Typography fontWeight={600} sx={{ width: 120 }}>
                          Department
                        </Typography>
                        <Typography fontWeight={600}>:</Typography>
                        <Typography>{userData?.department}</Typography>
                      </Box>

                      <Box display="flex" gap={1}>
                        <Typography fontWeight={600} sx={{ width: 130 }}>
                          Designation
                        </Typography>
                        <Typography fontWeight={600}>:</Typography>
                        <Typography>{userData?.designation}</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
              <Box>
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    border: `1px solid ${themes?.miliedLightGray}`,
                  }}
                >
                  <CardHeader
                    title="Current Assignment"
                    titleTypographyProps={{
                      variant: "h6",
                      fontWeight: 700,
                      color: themes?.mutedpurple,
                      fontSize: 18,
                    }}
                  />
                  <CardContent>
                    {assignmentItems.map((item, index) => (
                      <Accordion
                        key={index}
                        expanded={expanded.includes(index)}
                        sx={{
                          "&:before": { display: "none" },
                          boxShadow: "none",
                          borderBottom:
                            index !== assignmentItems.length - 1
                              ? `1px solid ${themes?.miliedLightGray}`
                              : "none",
                          borderRadius: 0,
                          m: 0,
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            expanded.includes(index) ? (
                              <CustomButtonWithBorder
                                actionName="Cancel"
                                typeName="button"
                                actionFuntion={() => handleChange(index, item)}
                              />
                            ) : (
                              <CustomButtonWithBorder
                                actionName="Change"
                                typeName="button"
                                actionFuntion={() => handleChange(index, item)}
                              />
                            )
                          }
                          sx={{
                            "& .MuiAccordionSummary-expandIconWrapper": {
                              transform: "none !important",
                            },
                          }}
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            width="80%"
                            gap={2}
                          >
                            <Box display="flex" alignItems="center" gap={2}>
                              <Box
                                display="flex"
                                flexDirection="column"
                                sx={{ ml: 0.4 }}
                              >
                                {item.icon}
                              </Box>

                              <Box display="flex" flexDirection="column">
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {item.category}
                                </Typography>
                                <Typography variant="body1" fontWeight={600}>
                                  {item.value}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              display="flex"
                              flexDirection="column"
                              alignItems="flex-end"
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                Effective from
                              </Typography>
                              <Typography
                                variant="body1"
                                fontWeight={600}
                                sx={{ paddingRight: 0.7 }}
                              >
                                {item.effective_from}
                              </Typography>
                            </Box>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box>
                            <Box>{renderAutoComplete(item)}</Box>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </CardContent>
                </Card>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
                mt: 2,
              }}
            >
              <CustomButtonWithBorder
                actionName="Cancel"
                typeName="button"
                actionFuntion={() => onClose()}
              />
              {expanded.length > 0 ? (
                <CustomButton
                  actionName="Update"
                  typeName="submit"
                  disableAction={watch("button_loader")}
                />
              ) : (
                <CustomButtonWithOutLoader
                  actionName="Update"
                  typeName="button"
                  disableAction={true}
                />
              )}
            </Box>
          </Box>
        </Box>
      </form>
    </React.Fragment>
  );
};
